import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout-only parent for the /adrs section. Without this file rendering
 * just an `<Outlet />`, TanStack's file router would nest /adrs/$slug as
 * a child of an /adrs page that doesn't exist — see the auto-nesting
 * note in CLAUDE.md.
 */
export const Route = createFileRoute('/adrs')({
  component: AdrLayout,
});

function AdrLayout() {
  return <Outlet />;
}
